
export default (v) => {
    return (v.indexOf('@', 1) > 0 && /^([A-Za-z0-9][A-z0-9.-]+)(\@\b)([_A-Za-z0-9]+.)((\.[A-Za-z0-9]{2,})+)$/g.test(v))
}



// WEBPACK FOOTER //
// ./src/utils/emailCheck.js